export default "__VITE_PUBLIC_ASSET__bf9ad707__"